import { Component, EventEmitter, HostBinding, Input, Output } from '@angular/core';
import { ButtonBaseComponent } from './button-base.component';


@Component({
	selector: 'app-button-cancel',
	templateUrl: './CoreButtonRaised.html'
})
export class ButtonCancelComponent extends ButtonBaseComponent {
	@HostBinding('class') class = 'adn-material-button';

	@Input()
	public iconClass = 'fa-ban';
	@Input()
	public titleTranslateKey = 'button.cancel';
	@Input()
	public disabled: boolean = false;

	@Input()
	public type = 'button';


	@Input()
	public hintTranslateKey: string;

	@Input()
	public color: string;

	@Output()
	action: EventEmitter<ButtonBaseComponent> = new EventEmitter<ButtonBaseComponent>();
}